import { type YDatabase } from '@databases/collab/y-database';
import { CollabFilterType } from '@databases/model/views/view-filter';
import { v4 as uuidv4 } from 'uuid';

/**
 * This migration adds a filter id to all existing database filters.
 */
export const filterId = {
  version: 1744236103431, // Timestamp of the migration when it's written
  apply(documentId: string, ydb: YDatabase) {
    for (const viewId of ydb.views) {
      const view = ydb.viewsById[viewId];
      // Once a filter is saved to a view, a parent AND CollabFilter will always be added as the top level
      // parent of all filters
      const topLevelFilter = view.filter;

      if (topLevelFilter) {
        // Sets the id if it has been affected by the filter type update bug which omits id and
        // creates a new filter
        if (!topLevelFilter.id) {
          topLevelFilter.id = uuidv4();
        }

        // Valid boolean CollabFilters include AND and OR, with AND being the default unless the user has
        // explicitly changed the boolean type
        if (
          topLevelFilter.type === CollabFilterType.AND ||
          topLevelFilter.type === CollabFilterType.OR
        ) {
          // Sets the id for each CollabFilter that is not a boolean type
          // Currently, nested filtering is not supported so none of the filters encompassed within the
          // boolean top level filter will be a boolean type
          topLevelFilter.value.forEach((filter) => {
            // Sets the id if it has been affected by the filter type update bug which omits id and
            // creates a new filter
            if (!filter.id) {
              filter.id = uuidv4();
            }
          });
        }
      }
    }
  }
};
